var React = require('react');

function ExpandRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12.44.44a1.5 1.5 0 012.12 0L36 21.877a2.998 2.998 0 01.004 4.24l-.002.003-21.44 21.44a1.5 1.5 0 01-2.122-2.122L33.88 24 12.439 2.56a1.5 1.5 0 010-2.12zM33.878 24l.001-.002-.001.002z"}));
}

ExpandRight.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = ExpandRight;

ExpandRight.default = ExpandRight;
